/** Количество отображаемых дней тайм-слотов */
export const TIME_SLOTS_DAYS_COUNT = 3;

export const BROKERAGE_ACCOUNT = 'BROKERAGE_ACCOUNT';

export const DEFAULT_PLATFORM_ID = 'alfasite';
export const PLATFORM_ID_KEY = 'platformId';

export const BROKERAGE_CHILD_MIN_AGE = 14;
export const BROKERAGE_CHILD_MAX_AGE = 18;

/** Статус-результат обработки заявки */
export const STATUS = {
    SUCCESS: 'SUCCESS',
    NODT: 'NODT',
    NO_OFFER: 'NO_OFFER',
    REFER_TO_OFFICE: 'REFER_TO_OFFICE ',
    REJECT_COMPLETELY: 'REJECT_COMPLETELY ',
    NEED_DUL: 'NEED_DUL',
    SMS_ERROR: 'SMS_ERROR',
} as const;

// https://confluence.moscow.alfaintra.net/pages/viewpage.action?pageId=1329243309
/** Последний статус первого шага  */
export const LAST_DT_PATH_STATUS = {
    SUCCESS: 'SUCCESS',
    NODT_ALL: 'NODT_ALL',
    NODT_ALL_CW: 'NODT_ALL_CW',
    NODT_O: 'NODT_O',
    NODT_EXDT: 'NODT_EXDT',
    NO_OFFER: 'NO_OFFER',
    REFER_TO_OFFICE: 'REFER_TO_OFFICE',
    REJECT_COMPLETELY: 'REJECT_COMPLETELY',
    NEED_DUL: 'NEED_DUL',
} as const;

export const FORM_STEPS = {
    /** Первый шаг анкеты */
    firstStep: 'firstStep',
    /** Смс подтверждение */
    smsConfirm: 'smsConfirm',
    /** Уточнение номера паспорта */
    passport: 'passport',
    /** Доставка */
    delivery: 'delivery',
    /** Смена номера телефона */
    changePhoneNumber: 'changePhoneNumber',
    /** Ошибка */
    error: 'error',
    /** Экран перехода на смс */
    checkData: 'checkData',
    /** Экран спасибо-страница */
    thanksPage: 'thanksPage',
    /** Экран черновика */
    draft: 'draft',
    /** Экран вежливой ошибки (например, закончились карты) */
    gentleErrorPage: 'gentleErrorPage',
} as const;
